<button type="button" class="back-button" (click)="back()">Back to {{ title }}</button>
